import { getCookie } from "../cookie";
export default function updateAuth() {
    var isAuthenticated = !!(getCookie("acm_ulm_access_token") || getCookie("acm_ulm_refresh_token"));
    return isAuthenticated;
}
